module.exports = __webpack_public_path__ + "img/about-1.b93cb511.jpg";